
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"7","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 0h6v7H4V0z"}}),_c('path',{attrs:{"d":"M0 3.5A1.5 1.5 0 011.5 2h11a1.5 1.5 0 010 3h-11A1.5 1.5 0 010 3.5z"}})])
          )
        }
      }
    